import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { TransformedToken } from 'style-dictionary'
import { Button, DotsHorizontal, Popper } from '@dashboard/ui'

import { Badge, TableCell, TableRow } from '@/ui'
import { LinkedIcon } from '../icons/Linked'
import { TokenStudioTokenPreview } from './TokenStudioTokenPreview'
import { TokenStudioTokenMenu } from './TokenStudioTokenMenu'

interface TokenStudioTokenRowProps {
  token: TransformedToken
}

export const TokenStudioTokenRow = ({ token }: TokenStudioTokenRowProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref)

  const hasLinkedColor = typeof token.original.value === 'string' ? token.original.value.startsWith('{') : false

  const onClickLinkedColor = (tokenValue: string) => {
    const path = tokenValue.replace('{', '').replace('}', '').split('.')
    const row = document.getElementById(`token-${path.join('.')}`)

    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' })
      row.style.backgroundColor = '#fffacd'
      setTimeout(() => {
        row.style.backgroundColor = '#fff'
      }, 1000)
    }
  }

  return (
    <TableRow ref={ref} id={`token-${token.path.join('.')}`} className="h-[64px]">
      {inView ? (
        <>
          <TableCell width={80} />
          <TableCell width="150%">
            <div>{token.path.at(-1)}</div>
          </TableCell>
          <TableCell width="200%">
            {hasLinkedColor && (
              <Badge
                className="cursor-pointer"
                variant="gray-secondary"
                onClick={() => onClickLinkedColor(token.original.value)}
              >
                {token.original.type === 'color' ? (
                  <>
                    <LinkedIcon />
                    <span className="min-w-0 truncate text-sm">{token.original.value}</span>
                  </>
                ) : (
                  'UNSUPPORTED LINK'
                )}
              </Badge>
            )}
          </TableCell>
          <TableCell width="75%">
            <TokenStudioTokenPreview token={token} />
          </TableCell>
          <TableCell width="75%">{token.description}</TableCell>
          <TableCell width={128}>
            <Popper
              popper={props => <TokenStudioTokenMenu {...props} token={token} />}
              params={{ placement: 'bottom-end' }}
            >
              <Button className="w-7 px-0" size="sm" variant="outline" color="secondary">
                <DotsHorizontal size={14} />
              </Button>
            </Popper>
          </TableCell>
        </>
      ) : (
        <>
          <TableCell width={80} />
          <TableCell width="150%">
            <div className="max-w-0 truncate text-transparent">
              {JSON.stringify({ path: token.path.join('.'), name: token.path.at(-1), value: token.value })}
            </div>
          </TableCell>
        </>
      )}
    </TableRow>
  )
}
